import { ROUTE_PARAMS } from "@/constants";
import { Navigate, useParams } from "react-router";

export default function NavigateToAccountAccessDenied() {
  const { [ROUTE_PARAMS.ACCOUNT_ID]: accountId } = useParams();

  if (!accountId) {
    return null;
  }

  return (
    <Navigate
      to={`/${accountId}/${ROUTE_PARAMS.ACCOUNT_ACCESS_DENIED}`}
      replace
    />
  );
}
